import VehicleAccessoriesServiceLister from "./VehicleAccessoriesServiceLister";

export default VehicleAccessoriesServiceLister;
